import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { getStats, type AdminStats } from "../api/admin";

const tileStyle: React.CSSProperties = {
  padding: 20,
  border: "1px solid var(--border)",
  borderRadius: "var(--radius-md)",
  background: "var(--surface)",
};

export function StatsPage() {
  const { api } = useAuth();
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getStats(api).then((r) => setStats(r.stats)).catch((e) => setError(e.message));
  }, [api]);

  const tiles: Array<{ label: string; value: number | string; warn?: boolean }> = stats
    ? [
        { label: "Active accounts", value: stats.accounts_active },
        { label: "Deleted accounts", value: stats.accounts_deleted },
        { label: "Accounts with 2FA", value: stats.accounts_2fa },
        { label: "Active devices", value: stats.devices_active },
        { label: "Paired Prism installs", value: stats.servers_paired },
        { label: "Active refresh sessions", value: stats.sessions_active },
        { label: "Open invites", value: stats.invites_open },
        { label: "Auth events (last hour)", value: stats.events_1h },
        { label: "Failed logins (24h)", value: stats.failed_logins_24h, warn: stats.failed_logins_24h > 10 },
      ]
    : [];

  return (
    <div className="vstack">
      <div>
        <h1>Platform stats</h1>
        <p className="meta">Aggregate counts across every account on this Prism deployment.</p>
      </div>
      {error && <div className="error">{error}</div>}
      {!stats && !error && <p className="meta">Loading…</p>}
      {stats && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
          {tiles.map((t) => (
            <div key={t.label} style={tileStyle}>
              <div className="subtle" style={{ marginBottom: 6 }}>{t.label}</div>
              <div style={{ fontSize: 28, fontWeight: 500, color: t.warn ? "var(--warn)" : "var(--text)" }}>
                {t.value}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
